/* Sacred Sin — PDP enhancements
 * 1. | in title -> <br>
 * 2. Wrap title + price in flex row
 * 3. Wrap variant-picker + buy-buttons in flex row
 * 4. Build custom gallery (main left + scrolling right column)
 * 5. Scroll-reveal stagger on info blocks
 * NOTE: ATC char-roll is handled globally by ss-animations.js
 */
(function () {

  /* --- IntersectionObserver for reveal ----------------------- */
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  /* --- Build custom gallery ---------------------------------- */
  function buildGallery() {
    var dataEl = document.getElementById('ss-media-data');
    var mediaEl = document.querySelector('.product-detail__media');
    if (!dataEl || !mediaEl) return;

    var images;
    try { images = JSON.parse(dataEl.textContent.trim()); } catch (e) { return; }
    if (!images || images.length < 1) return;

    // PDP starts from 2nd image; 1st image is reserved for collection grid
    var main = images.length > 1 ? images[1] : images[0];
    var sides = images.length > 2 ? images.slice(2) : [main];

    var slides = sides.map(function (img) {
      return '<div class="ss-gallery__slide"><img src="' + img.src +
             '" alt="' + img.alt + '" loading="lazy"></div>';
    }).join('');

    // Gallery images start from index 1 (index 0 is reserved for collection card)
    var galleryImgs = images.length > 1 ? images.slice(1) : images;
    var total = galleryImgs.length;
    var current = 0;

    var chevL = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    var chevR = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    var zoomSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>';

    var html = '<div class="ss-gallery">' +
      '<div class="ss-gallery__main">' +
        '<button class="ss-gallery__nav ss-gallery__nav--prev" aria-label="Previous image">' + chevL + '</button>' +
        '<span class="ss-gallery__counter">1 / ' + total + '</span>' +
        '<img src="' + galleryImgs[0].src + '" alt="' + galleryImgs[0].alt + '" loading="eager">' +
        '<button class="ss-gallery__nav ss-gallery__nav--next" aria-label="Next image">' + chevR + '</button>' +
        '<button class="ss-gallery__zoom" aria-label="Zoom image">' + zoomSvg + '</button>' +
      '</div>' +
      '<div class="ss-gallery__side">' +
        '<div class="ss-gallery__track">' +
          slides +
        '</div>' +
      '</div>' +
    '</div>';

    var frag = document.createRange().createContextualFragment(html);
    mediaEl.prepend(frag);

    Array.from(mediaEl.children).forEach(function (child) {
      if (!child.classList.contains('ss-gallery')) {
        child.style.cssText = 'display:none!important;visibility:hidden!important;';
      }
    });

    var mainImg  = mediaEl.querySelector('.ss-gallery__main img');
    var counter  = mediaEl.querySelector('.ss-gallery__counter');
    var prevBtn  = mediaEl.querySelector('.ss-gallery__nav--prev');
    var nextBtn  = mediaEl.querySelector('.ss-gallery__nav--next');
    var zoomBtn  = mediaEl.querySelector('.ss-gallery__zoom');

    function goTo(idx) {
      current = (idx + total) % total;
      var img = galleryImgs[current];
      mainImg.src = img.src;
      mainImg.alt = img.alt;
      counter.textContent = (current + 1) + ' / ' + total;
    }

    if (total > 1) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); });
      nextBtn.addEventListener('click', function () { goTo(current + 1); });
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    // Zoom lightbox with prev/next navigation
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var lbIdx = current;
        var navHtml = total > 1
          ? '<button class="ss-lightbox__nav ss-lightbox__nav--prev" aria-label="Previous image">' + chevL + '</button>' +
            '<button class="ss-lightbox__nav ss-lightbox__nav--next" aria-label="Next image">' + chevR + '</button>'
          : '';
        var overlay = document.createElement('div');
        overlay.className = 'ss-lightbox';
        overlay.innerHTML = '<div class="ss-lightbox__inner"><img src="' + galleryImgs[lbIdx].src + '" alt="' + galleryImgs[lbIdx].alt + '"><button class="ss-lightbox__close" aria-label="Close">&times;</button>' + navHtml + '</div>';
        document.body.appendChild(overlay);
        requestAnimationFrame(function () { overlay.classList.add('ss-lightbox--open'); });
        var lbImg = overlay.querySelector('.ss-lightbox__inner img');
        function lbGoTo(idx) {
          lbIdx = (idx + total) % total;
          lbImg.src = galleryImgs[lbIdx].src;
          lbImg.alt = galleryImgs[lbIdx].alt;
        }
        if (total > 1) {
          overlay.querySelector('.ss-lightbox__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); lbGoTo(lbIdx - 1); });
          overlay.querySelector('.ss-lightbox__nav--next').addEventListener('click', function (e) { e.stopPropagation(); lbGoTo(lbIdx + 1); });
        }
        function close() { overlay.classList.remove('ss-lightbox--open'); setTimeout(function () { overlay.remove(); }, 300); }
        overlay.querySelector('.ss-lightbox__close').addEventListener('click', close);
        overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      });
    }
  }

  /* --- Force all ATC buttons to Add to Cart ------------------ */
  function fixAtcBtn() {
    document.querySelectorAll('button[name="add"]').forEach(function (btn) {
      btn.removeAttribute('disabled');
      var lbl = btn.querySelector('.btn-label');
      if (lbl) lbl.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to Cart';
    });
  }

  /* --- Custom SS size selector -------------------------------- */
  function buildSizeSelector() {
    var vrEl = document.querySelector('variant-radios-detail');
    if (!vrEl) return;

    var jsonEl = vrEl.querySelector('script[type="application/json"]');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent.trim()); } catch (e) { return; }
    if (!variants || !variants.length) return;

    // Collect unique option1 values in order + track availability
    var seen = {};
    var options = [];
    var availableOptions = {};
    variants.forEach(function (v) {
      if (!seen[v.option1]) { seen[v.option1] = true; options.push(v.option1); }
      if (v.available) availableOptions[v.option1] = true;
    });
    if (!options.length) return;

    // Find which option is currently selected
    var formInput = document.querySelector('input[name="id"]');
    var currentId = formInput ? parseInt(formInput.value, 10) : null;
    var currentVariant = variants.find(function (v) { return v.id === currentId; });
    var activeOption = currentVariant ? currentVariant.option1 : options[0];

    // Build wrapper
    var wrap = document.createElement('div');
    wrap.className = 'ss-sizes';
    options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      var soldout = !availableOptions[opt] ? ' ss-size-btn--soldout' : '';
      btn.className = 'ss-size-btn' + (opt === activeOption ? ' ss-size-btn--active' : '') + soldout;
      btn.textContent = opt;
      btn.dataset.value = opt;
      wrap.appendChild(btn);
    });

    // Hide Glozin's fieldset (keep in DOM so Glozin's JS can still read radio state)
    var fieldset = vrEl.querySelector('fieldset.product-form__input');
    if (fieldset) fieldset.style.cssText = 'display:none!important';

    vrEl.insertBefore(wrap, fieldset || vrEl.firstChild);

    // Handle clicks
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.ss-size-btn');
      if (!btn) return;
      var value = btn.dataset.value;

      // Update our active state
      wrap.querySelectorAll('.ss-size-btn').forEach(function (b) {
        b.classList.toggle('ss-size-btn--active', b.dataset.value === value);
      });

      // Fire Glozin's hidden radio so price/media/URL update correctly
      if (fieldset) {
        var radio = fieldset.querySelector('input[type="radio"][value="' + value.replace(/"/g, '\\"') + '"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // After Glozin's sync handler runs, re-enable ATC
      setTimeout(fixAtcBtn, 0);
    });

  }

  /* --- Main init --------------------------------------------- */
  function init() {
    buildGallery();

    // 1. | -> split into main · sub spans (mirrors ss-collection card)
    var titleEl = document.querySelector('.product-detail__title');
    if (titleEl && titleEl.textContent.includes('|')) {
      var parts = titleEl.textContent.split(/\s*\|\s*/);
      titleEl.innerHTML =
        '<span class="pdp-title__main">' + parts[0].trim() + '</span>' +
        '<span class="pdp-title__sep"> •</span>' +
        '<span class="pdp-title__sub">' + (parts[1] || '').trim() + '</span>';
    }

    // 2. Wrap title + price
    var title = document.querySelector('.product-detail__title');
    var price  = document.querySelector('.product-detail__price');
    if (title && price && !document.querySelector('.ss-title-price-row')) {
      var tpWrap = document.createElement('div');
      tpWrap.className = 'ss-title-price-row';
      title.parentNode.insertBefore(tpWrap, title);
      tpWrap.appendChild(title);
      tpWrap.appendChild(price);
    }

    // 3. Wrap variant-picker + buy-buttons
    var picker  = document.querySelector('.product-detail__variant-picker');
    var buyBtns = document.querySelector('.product-detail__buy-buttons');
    if (picker && buyBtns && !document.querySelector('.ss-size-atc-row')) {
      var sabWrap = document.createElement('div');
      sabWrap.className = 'ss-size-atc-row';
      picker.parentNode.insertBefore(sabWrap, picker);
      sabWrap.appendChild(picker);
      sabWrap.appendChild(buyBtns);
    }

    // 4. Custom size selector — bypasses Glozin's option-disabled/available logic entirely
    buildSizeSelector();

    // Fix all ATC buttons unconditionally (covers single-variant products + sticky bar)
    setTimeout(fixAtcBtn, 0);

    // 5. Staggered scroll-reveal on info blocks
    var info = document.querySelector('.product-detail__information');
    if (info) {
      var stickyDiv = info.querySelector('.sticky') || info;
      var blocks = stickyDiv.children;
      var delay = 0;
      for (var i = 0; i < blocks.length; i++) {
        if (!blocks[i].classList.contains('ss-reveal')) {
          blocks[i].classList.add('ss-reveal');
          blocks[i].style.transitionDelay = delay + 'ms';
          revealObs.observe(blocks[i]);
          delay += 80;
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
